import { formatCurrencyValues } from "../../utils/convertUtils";

const mapCard = (json) => {
    const {
        Description,
        CurrentValue,
        CurrentValueYearN1,
        CurrentValueYearN2,
        CurrentValueYearN3,
        CurrencyOptions,
    } = json;

    return [
        [{ labels: ["Descripttion"], value: Description, type: "string" }],
        [
            {
                labels: ["CurrentValue"],
                value: formatCurrencyValues(CurrencyOptions, CurrentValue),
                type: "currency",
            },
        ],
        [
            {
                labels: ["CurrentValueYearN1"],
                value: formatCurrencyValues(CurrencyOptions, CurrentValueYearN1),
                type: "currency",
            },
        ],
        [
            {
                labels: ["CurrentValueYearN2"],
                value: formatCurrencyValues(CurrencyOptions, CurrentValueYearN2),
                type: "currency",
            },
        ],
        [
            {
                labels: ["CurrentValueYearN3"],
                value: formatCurrencyValues(CurrencyOptions, CurrentValueYearN3),
                type: "currency",
            },
        ],
    ];
};

const header = [
    { label: ["Description"], align: "left" },
    { label: ["Current"], align: "right" },
    { label: ["N1"], align: "right" },
    { label: ["N2"], align: "right" },
    { label: ["N3"], align: "right" },
];

const mapper = (json, card) => {
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
        link: {
            to: "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix/reports/nc_trial_balance_taxonomy_pluriannual",
            appendFilters: ["Period"],
            filter: [
                {
                    filters: [{ value: json.KPIKey }],
                    column: "Code",
                },
                {
                    filters: [{ value: "NRJA" }],
                    column: "CLB_TransactionType",
                },
            ],
        },
    };
};

const balancesheetMapper = {
    map: mapper,
    header,
};

export default balancesheetMapper;
